import { EventEmitter, Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ItineraryFormComponent } from 'src/app/modules/inventory-itinerary/add/itinerary-form.component';
import { LeadFormComponent } from 'src/app/modules/lead-managment/add/lead-form.component';
import { AddTaskComponent } from 'src/app/modules/tasks/add/add-task.component';
import { ReviewItineraryComponent } from 'src/app/modules/inventory-itinerary/review-itinerary/review-itinerary.component';
import { InvoiceFormComponent } from 'src/app/modules/invoice/add/invoice-form.component';
import { ItineraryViewComponent } from 'src/app/modules/inventory-itinerary/view/itinerary-view.component';
import { VoucherFormComponent } from 'src/app/modules/voucher/add/voucher-form.component';
import { PaymentFormComponent } from 'src/app/modules/invoice/add-payment/payment-form.component';
import { ContactFormComponent } from 'src/app/modules/contacts/add/contact-form.component';
import { VoucherViewTemplateComponent } from 'src/app/modules/voucher/view/voucher-view-template.component';
import { MultiPointInputComponent } from '../../inputs/multi-point-input/multi-point-input.component';
import { ImageViewComponent } from '../../image-view/image-view.component';
import { ClientFormComponent } from 'src/app/modules/clients/add/client-form.component';
import { ChatViewComponent } from 'src/app/modules/chats/chat-view/chat-view.component';
import { TemplateFormComponent } from 'src/app/modules/inventory-templates/template-form/template-form.component';
import { VisaFormComponent } from 'src/app/modules/visa/add/visa-form.component';
import { AddUserComponent } from 'src/app/modules/client-admin/add-user/add-user.component';
import { VisaReviewComponent } from 'src/app/modules/visa/visa-review/visa-review.component';
import { VisaImportantInformationFormComponent } from 'src/app/modules/inventory-visa-information/add/visa-important-information-form.component';
import { VisaImportantInformationViewComponent } from 'src/app/modules/inventory-visa-information/view/visa-important-information-view.component';
import { DmcPackagesFormComponent } from 'src/app/modules/dmc-packages/add/dmc-packages-form.component';
import { OrganizationFormComponent } from 'src/app/modules/admin/add/organization-form.component';
import { DmcPackagesReviewComponent } from 'src/app/modules/dmc-packages/review/dmc-packages-review.component';
import { AddHotelComponent } from 'src/app/modules/inventory-hotels/add-hotel/add-hotel.component';
import { AddVehicleComponent } from 'src/app/modules/inventory-vehicles/add-vehicle/add-vehicle.component';
import { DmcLeadFormComponent } from 'src/app/modules/dmc-lead-management/add/dmc-lead-form.component';
import { EmailPopUpComponent } from 'src/app/modules/contacts/email-pop-up/email-pop-up.component';
import { BulkUploadComponent } from '../../bulk-upload/bulk-upload.component';
import { PrivacyAndPolicyComponent } from 'src/app/extensions/privacy-and-policy/privacy-and-policy.component';
import { PaymentManagementComponent } from 'src/app/modules/payment-management/payment-management.component';
import { DmcClientFormComponent } from 'src/app/modules/dmc-client-management/add/dmc-client-form.component';
import { DmcQuoteFormComponent } from 'src/app/modules/dmc-quote-management/add/dmc-quote-form.component';
import { DmcQuoteViewComponent } from 'src/app/modules/dmc-quote-management/view/dmc-quote-view.component';
import { AuditHistoryViewComponent } from '../../audit-history-view/audit-history-view.component';
import { PayuPaymentInvoiceViewComponent } from 'src/app/modules/payment-management/invoice-view/payu-payment-invoice-view.component';
import { TaskReminderModalComponent } from 'src/app/modules/tasks/task-reminder-modal/task-reminder-modal.component';
import { WhatsappCampaignFormComponent } from 'src/app/modules/whatsapp-campaign/add/whatsapp-campaign-form.component';
import { AddTemplateComponent } from 'src/app/modules/whatsapp-template-management/template-builder/add-template/add-template.component';
import { TemplateBuilderComponent } from 'src/app/modules/whatsapp-template-management/template-builder/template-builder.component';

@Injectable({
  providedIn: 'root'
})
export class ModalsService {

  // Opeded modals
  openModals: HTMLIonModalElement[] = [];

  constructor(
    private _modalController: ModalController,
  ) { }


  ////////////////////
  // Open modal popups
  ////////////////////

  // Add modal to openModals
  addModalToArray(modal: any) {
    this.openModals.push(modal);
  }

  // Close all modals

  async closeAllModals() {
    for (const modal of this.openModals) {
      await modal.dismiss();
    }
    this.openModals = [];
  }


  // itinerary form
  async openItineraryForm(clientId: any, leadId: any, quoteItineraryId: any, InventoryItineraryId: any, recommendedItinerary: any = null, cloneItineraryId: any = null, targetTab: string = "") {

    const modal = await this._modalController.create({
      component: ItineraryFormComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        leadId: leadId,
        clientId: clientId,
        editInventoryItineraray: InventoryItineraryId,
        editQuoteItinerary: quoteItineraryId,
        recommendedItineraryId: recommendedItinerary?.recommendedItineraryId,
        recommendedItineraryType: recommendedItinerary?.recommendedItineraryType,
        recommendedOrganizationId: recommendedItinerary?.recommendedOrganizationId,
        cloneItineraryId: cloneItineraryId,
        targetTab: targetTab || null
      }
    })

    this.openModals.push(modal);
    return await modal.present();
  }

  // Quote view
  async openReviewItineraryView(quoteItineraryId: any, leadId: any, clientId: any) {
    const modal = await this._modalController.create({
      component: ReviewItineraryComponent,
      backdropDismiss: false,
      cssClass: 'view-a4-side-modal',
      componentProps: {
        quoteId: quoteItineraryId,
        leadId: leadId,
        clientId: clientId
      }
    })

    this.openModals.push(modal);
    return await modal.present();
  }


  //  lead form
  async openLeadForm(editLeadId: any, clientId: any) {
    const modal = await this._modalController.create({
      component: LeadFormComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        editLeadId: editLeadId,
        clientId: clientId,
      }
    });

    this.openModals.push(modal);
    await modal.present();
    const { data } = await modal.onDidDismiss();
    return data;
  }

  //  contact form
  async openContactForm(relatedTo: any, leadId: any, editContactId: any, disabledRelatedTo: any, callback: (goNew: boolean, contactId: any) => void) {
    const formSubmitted: EventEmitter<{ goNew: boolean, contactId?: any }> = new EventEmitter();

    const modal = await this._modalController.create({
      component: ContactFormComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        relatedTo: relatedTo,
        leadId: leadId,
        editContactId: editContactId,
        formSubmitted: formSubmitted,
        disabledRelatedTo: disabledRelatedTo
      }
    });

    formSubmitted.subscribe(({ goNew, contactId }) => {
      callback(goNew, contactId);
    });

    this.openModals.push(modal);
    return await modal.present();
  }


  // Open task form model

  async openTasksForm(editTaskId: any, leadId: any, callback: (goNew: boolean) => void) {
    const formSubmitted: EventEmitter<{ goNew: boolean }> = new EventEmitter();

    const modal = await this._modalController.create({
      component: AddTaskComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css my-modal-medium-component-css',
      componentProps: {
        editTaskId: editTaskId,
        leadId: leadId,
        formSubmitted: formSubmitted
      }
    });

    formSubmitted.subscribe(({ goNew }) => {
      callback(goNew);
    });

    this.openModals.push(modal);
    return await modal.present();
  }

  // Invoice form
  async openInvoiceForm(editInvoiceId: any, leadId: any, quoteId: any, callback: (goNew: boolean) => void) {
    const formSubmitted: EventEmitter<{ goNew: boolean }> = new EventEmitter();

    const modal = await this._modalController.create({
      component: InvoiceFormComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        editInvoiceId: editInvoiceId,
        leadId: leadId,
        quoteId: quoteId,
        formSubmitted: formSubmitted
      }
    });

    formSubmitted.subscribe(({ goNew }) => {
      callback(goNew);
    });

    this.openModals.push(modal);
    return await modal.present();
  }

  // Open payments form model

  async openPaymentForm(editPaymentId: any, invoiceId: any, forRefund: boolean, leadId: any = null) {
    const modal = await this._modalController.create({
      component: PaymentFormComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css my-modal-medium-component-css',
      componentProps: {
        editPaymentId: editPaymentId,
        invoiceId: invoiceId,
        forRefund: forRefund,
        leadId: leadId
      }
    });

    this.openModals.push(modal);
    return await modal.present();
  }

  // VOucher form open

  async openVoucherForm(editVoucherId: any, leadId: any, quoteId: any, callback: (goNew: boolean) => void) {

    const modal = await this._modalController.create({
      component: VoucherFormComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        editVoucherId: editVoucherId,
        leadId: leadId,
        quoteId: quoteId,
      }
    });

    this.openModals.push(modal);
    return await modal.present();
  }

  // Voucher view modal
  async openVocuherView(voucherId: any, leadId: any, quoteId: any) {
    const modal = await this._modalController.create({
      component: VoucherViewTemplateComponent,
      backdropDismiss: false,
      cssClass: 'view-a4-side-modal',
      componentProps: {
        voucherId: voucherId,
        leadId: leadId,
        quoteId: quoteId
      }
    })

    this.openModals.push(modal);
    return await modal.present();
  }

  // Inventory itinerary view modal
  async openInventoryItineraryView(itineraryId: any, leadId: any, clientId: any): Promise<any> {
    const modal = await this._modalController.create({
      component: ItineraryViewComponent,
      cssClass: 'inventory-itineray-view',
      componentProps: {
        itineraryId: itineraryId,
        leadId: leadId,
        clientId: clientId
      }
    });

    this.openModals.push(modal);
    await modal.present();
    const { data } = await modal.onDidDismiss();
    return data;
  }

  // Multi points modal popup

  async openMultiPointInput() {
    const modal = await this._modalController.create({
      component: MultiPointInputComponent,
      cssClass: 'multi-point-input',
    });

    this.openModals.push(modal);
    await modal.present();
    return modal; // Return the modal instance
  }

  async openImageModal(imgUrl: any) {
    const modal = await this._modalController.create({
      component: ImageViewComponent,
      backdropDismiss: true,
      cssClass: 'image-view-modal',
      componentProps: {
        imgSrc: imgUrl,
      }
    })

    this.openModals.push(modal);
    return await modal.present();
  }

  // Open client form modal

  async openClientForm(editClientId: any) {

    const modal = await this._modalController.create({
      component: ClientFormComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css my-modal-small-component-css',
      componentProps: {
        editClientId: editClientId
      }
    });

    this.openModals.push(modal);
    return await modal.present();
  }

  // Open chat view popup modal

  async openChatView() {
    const modal = await this._modalController.create({
      component: ChatViewComponent,
      cssClass: 'chat-view-modal',
      componentProps: {

      }
    });

    this.openModals.push(modal);
    return await modal.present();
  }

  // Email DMC modal pop-up
  async openEmailDmcModal(dmcId: any) {
    const modal = await this._modalController.create({
      component: EmailPopUpComponent,
      cssClass: 'my-modal-component-css',
      componentProps: {

      }
    });

    this.openModals.push(modal);
    return await modal.present();
  }



  // Inventory Template view
  async openEditInventoryTemplate(templateId: any, viewOnlyTemplate: boolean) {
    const modal = await this._modalController.create({
      component: TemplateFormComponent,
      backdropDismiss: false,
      cssClass: 'view-a4-side-modal',
      componentProps: {
        templateId: templateId,
        viewOnlyTemplate: viewOnlyTemplate
      }
    })

    this.openModals.push(modal);
    return await modal.present();
  }

  // Open modal for adding organization
  async openAddOrganizationForm(editOrganizationIdId: any, isUserEditing: boolean = false) {
    const modal = await this._modalController.create({
      component: OrganizationFormComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        editOrganizationId: editOrganizationIdId,
        isUserEditing: isUserEditing
      }
    });

    this.openModals.push(modal);
    return await modal.present();
  }

  // Open visa creation popup modal

  async openVisaCreationModal(leadId: any, editVisaId: any) {
    if (leadId) {
      const modal = await this._modalController.create({
        component: VisaFormComponent,
        backdropDismiss: false,
        cssClass: 'my-modal-component-css',
        componentProps: {
          leadId: leadId,
          editVisaId: editVisaId,
        }
      })

      this.openModals.push(modal);
      return await modal.present();
    }
  }

  async openVisaReviewScreen(visaId: any) {
    const modal = await this._modalController.create({
      component: VisaReviewComponent,
      backdropDismiss: false,
      cssClass: 'view-a4-side-modal',
      componentProps: {
        visaId: visaId
      }
    })

    this.openModals.push(modal);
    return await modal.present();
  }

  // add user open pop-up
  async openAddUserForm(editUserId: any, targetTab: string = 'userdetails') {
    const modal = await this._modalController.create({
      component: AddUserComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        editUserId: editUserId,
        targetTab: targetTab
      }
    });

    this.openModals.push(modal);
    return await modal.present();
  }

  // Inventory
  // Add country for visa info
  async openInventoryVisaInformationForm(editVisaInformationId: any = null) {
    const modal = await this._modalController.create({
      component: VisaImportantInformationFormComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        editVisaInformationId: editVisaInformationId
      }
    })

    this.openModals.push(modal);
    return await modal.present();
  }

  async openVisaCountryInventoryReview(countryId: any) {
    const modal = await this._modalController.create({
      component: VisaImportantInformationViewComponent,
      backdropDismiss: false,
      cssClass: 'view-a4-side-modal',
      componentProps: {
        countryId: countryId
      }
    })

    this.openModals.push(modal);
    return await modal.present();
  }

  async openDmcPackageForm(editPackageId: any = null) {
    const modal = await this._modalController.create({
      component: DmcPackagesFormComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        editPackageId: editPackageId
      }
    })
    this.openModals.push(modal);
    return await modal.present();
  }

  async openDmcPackageReview(packageId: any, leadId: any = "", organizationId: any = "", viewOnly: boolean = false): Promise<any> {
    const modal = await this._modalController.create({
      component: DmcPackagesReviewComponent,
      backdropDismiss: false,
      cssClass: 'view-a4-side-modal',
      componentProps: {
        packageId: packageId,
        leadId: leadId,
        organizationId: organizationId,
        viewOnly: viewOnly
      }
    })
    this.openModals.push(modal);
    await modal.present();
    const { data } = await modal.onDidDismiss();
    return data;
  }

  // Add Hotel 
  async openAddHotelForm(editHotelId: any) {
    const modal = await this._modalController.create({
      component: AddHotelComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        editHotelId: editHotelId
      }

    })
    this.openModals.push(modal);
    return await modal.present();
  }


  async openAddVehicleForm(transferId: any = null) {
    const modal = await this._modalController.create({
      component: AddVehicleComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        transferId: transferId
      }
    })
    this.openModals.push(modal);
    return await modal.present();
  }

  async openBulkUploadModal(configSettings: any, notesMessage: string = "") {
    const modal = await this._modalController.create({
      component: BulkUploadComponent,
      backdropDismiss: true,
      cssClass: 'my-modal-component-css',
      componentProps: {
        config: configSettings,
        notesMessage: notesMessage
      }
    });
    this.openModals.push(modal);
    await modal.present();
    const { data } = await modal.onDidDismiss();
    return data;
  }

  // Open modal for privacy and policy
  async openPrivacyAndPolicy() {
    const modal = await this._modalController.create({
      component: PrivacyAndPolicyComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css z-index-1',
      componentProps: {
      }
    });

    this.openModals.push(modal);
    return await modal.present();
  }

  // Upgrade to plan modal

  async openUpgradePlanModal(txnId: any = null) {
    const modal = await this._modalController.create({
      component: PaymentManagementComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css upgrade-modal-width',
      componentProps: {
        txnId: txnId
      }
    });

    this.openModals.push(modal);
    return await modal.present();
  }

  async openPayUInvoiceView(txnId: any) {
    const modal = await this._modalController.create({
      component: PayuPaymentInvoiceViewComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        txnId: txnId
      }
    });

    this.openModals.push(modal);
    return await modal.present();
  }


  ///////////////////////////
  //// DMC Modals Start /////
  ///////////////////////////

  async openDmcLeadForm(editLeadId: any) {
    const modal = await this._modalController.create({
      component: DmcLeadFormComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        editLeadId: editLeadId
      }
    })
    this.openModals.push(modal);
    return await modal.present();
  }

  async openDmcClientForm(editClientId: any) {
    const modal = await this._modalController.create({
      component: DmcClientFormComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css my-modal-small-component-css',
      componentProps: {
        editClientId: editClientId
      }
    })
    this.openModals.push(modal);
    return await modal.present();
  }

  async openDmcQuoteForm(clientId: any, leadId: any, quoteItineraryId: any, recommendedItinerary: any = null, targetTab: string = "") {

    const modal = await this._modalController.create({
      component: DmcQuoteFormComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        leadId: leadId,
        clientId: clientId,
        editQuoteItinerary: quoteItineraryId,
        recommendedItineraryId: recommendedItinerary?.recommendedItineraryId,
        recommendedItineraryType: recommendedItinerary?.recommendedItineraryType,
        recommendedOrganizationId: recommendedItinerary?.recommendedOrganizationId,
        targetTab: targetTab || null
      }
    })

    this.openModals.push(modal);
    return await modal.present();
  }

  async openReviewDmcQuoteView(quoteItineraryId: any, leadId: any, clientId: any) {
    const modal = await this._modalController.create({
      component: DmcQuoteViewComponent,
      backdropDismiss: false,
      cssClass: 'view-a4-side-modal',
      componentProps: {
        quoteId: quoteItineraryId,
        leadId: leadId,
        clientId: clientId
      }
    })

    this.openModals.push(modal);
    return await modal.present();
  }

  //////////////////////////
  //// DMC Modals End //////
  //////////////////////////

  async openAuditHistoryView(entityName: any, id: any, data: any, heading: any = null) {
    const modal = await this._modalController.create({
      component: AuditHistoryViewComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        entityName: entityName,
        id: id,
        heading: heading,
        allData: data
      }
    });

    this.openModals.push(modal);
    return await modal.present();
  }

  async openTaskReminderModal(tasks: any[]) {
    const modal = await this._modalController.create({
      component: TaskReminderModalComponent,
      backdropDismiss: false,
      cssClass: 'payment-reminder-modal',
      componentProps: {
        tasks: tasks
      }
    });

    this.openModals.push(modal);
    return await modal.present();
  }

  //  lead form
  async openWhatsappCampaignForm(editCampaignId: any) {
    const modal = await this._modalController.create({
      component: WhatsappCampaignFormComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-component-css',
      componentProps: {
        editCampaignId: editCampaignId,
      }
    });

    this.openModals.push(modal);
    await modal.present();
    const { data } = await modal.onDidDismiss();
    return data;
  }

  // Open modal for create WhatsApp template
  async openWhatsAppCreateTemaplteForm(templateId: any, isUserEditing: boolean = false, isViewOnly: boolean = false) {
    const modal = await this._modalController.create({
      component: TemplateBuilderComponent,
      backdropDismiss: false,
      cssClass: 'my-modal-large-component-css',
      componentProps: {
        templateId: templateId,
        isUserEditing: isUserEditing,
        isViewOnly: isViewOnly
      }
    });

    this.openModals.push(modal);
    return await modal.present();
  }


}
